import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface AvatarCacheContextType {
  /**
   * Глобальный счетчик версии аватаров
   */
  avatarCacheVersion: number;
  
  /**
   * Метод для обновления всех аватаров в приложении
   */
  invalidateAvatarsCache: () => void;
}

/**
 * Контекст для управления кешированием аватаров в приложении
 */
export const AvatarCacheContext = createContext<AvatarCacheContextType>({
  avatarCacheVersion: Date.now(),
  invalidateAvatarsCache: () => {},
});

interface AvatarCacheProviderProps {
  children: ReactNode;
}

/**
 * Провайдер контекста кеширования аватаров
 */
export const AvatarCacheProvider: React.FC<AvatarCacheProviderProps> = ({ children }) => {
  const [avatarCacheVersion, setAvatarCacheVersion] = useState<number>(Date.now());

  const invalidateAvatarsCache = useCallback(() => {
    setAvatarCacheVersion(Date.now());
  }, []);

  return (
    <AvatarCacheContext.Provider value={{ avatarCacheVersion, invalidateAvatarsCache }}>
      {children}
    </AvatarCacheContext.Provider>
  );
};

/**
 * Хук для использования контекста кеширования аватаров
 */
export const useAvatarCache = () => useContext(AvatarCacheContext); 